import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import PendingPtoIcon from 'src/icons/untitled-ui/duocolor/pto-icons/pending-pto';
import SuccessPtoIcon from 'src/icons/untitled-ui/duocolor/pto-icons/success-pto';
import RejectPtoIcon from 'src/icons/untitled-ui/duocolor/pto-icons/reject-pto';

const PtoStatusHover = ({ ptoData }: any) => {
  const IconsOfRejectPto = () => {
    return <RejectPtoIcon />;
  };

  const IconsSuccessPto = () => {
    return <SuccessPtoIcon />;
  };

  const IconsOfPendingPto = () => {
    return <PendingPtoIcon />;
  };

  const approvedPTO = ptoData?.filter((item: any) => item.ptoStatus === 'APPROVED');
  const pendingPTO = ptoData?.filter((item: any) => item.ptoStatus === 'PENDING');
  const rejectedPTO = ptoData?.filter((item: any) => item.ptoStatus === 'REJECTED');

  return (
    <div>
      {approvedPTO?.length !== 0 && (
        <Box>
          <Typography
            sx={{
              fontSize: '12px',
              color: '#fff',
              textTransform: 'uppercase',
              zIndex: 1,
              visibility: 'visible !important',
            }}
          >
            PTO APPROVED
          </Typography>
          {approvedPTO?.map((pto: any, index: any) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
              }}
            >
              <IconsSuccessPto />
              <Typography
                sx={{
                  color: '#FFF',
                  fontSize: '10px',
                  fontWeight: 500,
                }}
              >
                {pto.ptoHours} hrs PTO
              </Typography>
            </Box>
          ))}
        </Box>
      )}

      {pendingPTO.length !== 0 && (
        <Box mt={approvedPTO.length !== 0 ? 1 : 0}>
          <Typography
            sx={{
              fontSize: '12px',
              color: '#fff',
              textTransform: 'uppercase',
              fontWeight: 600,
            }}
          >
            PTO PENDING
          </Typography>
          {pendingPTO.map((pto: any, index: any) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
              }}
            >
              <IconsOfPendingPto />
              <Typography
                sx={{
                  color: '#fff',
                  fontSize: '10px',
                  fontWeight: 500,
                  zIndex: 999,
                  opacity: 1,
                }}
              >
                {pto.ptoHours} hrs PTO
              </Typography>
            </Box>
          ))}
        </Box>
      )}

      {rejectedPTO.length !== 0 && (
        <Box mt={pendingPTO.length !== 0 ? 1 : 0}>
          <Typography
            sx={{
              fontSize: '12px',
              color: '#fff',
              textTransform: 'uppercase',
              fontWeight: 600,
            }}
          >
            PTO REJECTED
          </Typography>
          {rejectedPTO.map((pto: any, index: any) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
              }}
            >
              <IconsOfRejectPto />
              <Typography
                sx={{
                  color: '#FFF',
                  fontSize: '10px',
                  fontWeight: 500,
                }}
              >
                {pto.ptoHours} hrs PTO
              </Typography>
            </Box>
          ))}
        </Box>
      )}
    </div>
  );
};

export default PtoStatusHover;
